import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    successTitle: {
        id: 'notifications.swap.success.title',
        defaultMessage: 'Swap completed',
    },
    successContent: {
        id: 'notifications.swap.success.content',
        defaultMessage: 'Balance: ',
    },
    pendingTitle: {
        id: 'notifications.swap.pending.title',
        defaultMessage: 'Swap is pending',
    },
    pendingContent: {
        id: 'notifications.swap.pending.content',
        defaultMessage: 'Confirming the swap transaction, please wait.',
    },
    errorTitle: {
        id: 'notifications.swap.error.title',
        defaultMessage: 'Error swap',
    },
    errorContent: {
        id: 'notifications.swap.error.content',
        defaultMessage: 'The swap transaction cannot be completed.',
    },
    errorACLContent: {
        id: 'notifications.swap.error.unavailable',
        defaultMessage: 'The swap is unavailable to you.<br/>Please contact support',
    },
    errorButton: {
        id: 'notifications.swap.error.button',
        defaultMessage: 'Try again',
    },
})
